import React, { Component } from 'react';
import { any, func } from 'prop-types';
import { Description } from '@material-ui/icons';
import { UTLabel } from '@widergy/energy-ui';

import UTList from 'app/components/UTList';

import styles from './styles';

export default class BillsMobileTable extends Component {
  onEndReached = () => this.props.onRowsRendered({ stopIndex: 0 }, true);

  rightButtonRender = period =>
    period && (
      <UTLabel darkGray small semibold>
        {period}
      </UTLabel>
    );

  formatBill = bill => ({
    id: bill.id,
    icon: <Description style={styles.billIcon} />,
    title: `${bill.download.amount}`,
    subtitle: `${bill.status}`,
    rightButton: this.rightButtonRender(bill.period)
  });

  render() {
    const formattedBills = this.props.bills.map(this.formatBill);

    return (
      <UTList
        style={styles.container}
        list={formattedBills}
        onClick={this.props.onSelectBill}
        onEndReached={this.onEndReached}
      />
    );
  }
}

BillsMobileTable.propTypes = {
  bills: any.isRequired, // eslint-disable-line react/forbid-prop-types
  onSelectBill: func.isRequired,
  onRowsRendered: func.isRequired
};
